import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaRegEyeSlash } from "react-icons/fa";
import { MdDragIndicator, MdSearch } from "react-icons/md";
import Button from "rsuite/Button";
import "rsuite/dist/rsuite.min.css";
import React, { useEffect, useRef, useState } from "react";
import { apiRequest } from "../../../../utils/utils";
import { getCookie } from "../../../common/Utility";
import { decrypt } from "../../../../actions/common";


const ColumnOrderManager = ({
  refetchGrid,
  setAgGridLoadColumns,
  columnsValueSearch,
  setColumnsValueSearch,
  attribute_set_key,
  columnsDef,
  hiddenColumns,
  setHiddenColumns,
}) => {
  let user_uuid = getCookie("muvi_useruuid");
  var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
  var localdata = has_local_data
    ? decrypt(localStorage.getItem("encdata"), 0)
    : "";

  const [showHiddenColumns, setShowHiddenColumns] = useState(false);
  const [searchAttributeColumns, setSearchAttributeColumns] = useState("");
  const [columnsData, setColumnsData] = useState([]);
  const [menuOrder, setMenuOrder] = useState(null);
  const [dateTypeAttr, setDateTypeAttr] = useState([]);
  const [isDateFilter, setIsDateFilter] = useState(false);
  const hiddenColumnShows = useRef(null);

  useEffect(() => {
    getTattleColumnSearch();

    document.addEventListener("mousedown", handleClickOutSide);

    return () => {
      document.removeEventListener("mousedown", handleClickOutSide);
    };
  }, [attribute_set_key, columnsDef]);

  const handleClickOutSide = (evt) => {
    if (
      hiddenColumnShows.current &&
      !hiddenColumnShows.current.contains(evt.target)
    ) {
      setShowHiddenColumns(false);
    }
  };

  const handleToggleDropdown = () => {
    setShowHiddenColumns((prev) => !prev);
  };

  const searchAttributeHandler = (evt) => {
    const { name, value } = evt.target;
    setSearchAttributeColumns(value);
  };

  const getTattleColumnSearch = async () => {

    if (!Array.isArray(columnsDef) || !columnsDef.length) return;

    const filteredColumns = columnsDef.filter(
      (item) => item.attribute_type !== "action"
    );

    const checkdatetype = filteredColumns
      .filter((item) => item.attribute_type === "date")
      .map((item) => item.field);

    const columsndata = filteredColumns
      .slice()
      .sort((a, b) => a.sequence - b.sequence)
      .map((item) => ({
        label: item.headerName,
        value: item.field,
      }));

    setColumnsData(columsndata);
    setDateTypeAttr(checkdatetype);
  };


  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const filtered = searchAttributeColumns
      ? columnsData.filter((item) =>
          item.label
            .toLowerCase()
            .includes(searchAttributeColumns.toLowerCase())
        )
      : columnsData;

    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;

    const draggedId = filtered[sourceIndex].value;

    // Clone original list
    const newOrder = [...columnsData];

    // Find real index of dragged item in original
    const fromIndex = newOrder.findIndex((c) => c.value === draggedId);
    const [removed] = newOrder.splice(fromIndex, 1);

    // ----------------------------
    // FIX: Calculate correct target
    // ----------------------------

    let toIndex;

    // If dropping after last filtered item
    if (destIndex === filtered.length - 1) {
      const lastId = filtered[destIndex].value;
      const lastRealIndex = newOrder.findIndex((c) => c.value === lastId);

      // If dragging downward -> insert AFTER lastRealIndex
      toIndex = fromIndex < lastRealIndex ? lastRealIndex + 1 : lastRealIndex;
    } else {
      // Normal case: item that should come AFTER the moved one
      const nextId = filtered[destIndex].value;
      let nextRealIndex = newOrder.findIndex((c) => c.value === nextId);

      // If dragging downward → adjust insertion index
      if (fromIndex < nextRealIndex) nextRealIndex++;

      toIndex = nextRealIndex;
    }

    newOrder.splice(toIndex, 0, removed);

    console.log("FIXED ORDER:", newOrder);
    setColumnsData(newOrder);

    const attributes = newOrder.map((col) => col.value);
    setMenuOrder(attributes);
  };

  const saveAndApplyOrder = async () => {
    setShowHiddenColumns(false);
    const payload = {
      app_token: process.env.REACT_APP_tattle_token,
      user_uuid: user_uuid || "45cfe77780ec435cb7ba63618e013baa",
      attribute_set_key,
      attributes: menuOrder,
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_tattle_api}/sequence`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.code || data.code == 200) {
        refetchGrid();
        setMenuOrder(null);
      }
      console.log("API Response:", data);
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  const getTheHiddenColumns = () => {
    const filteredColumns = searchAttributeColumns
      ? columnsData.filter((item) =>
          item.label
            .toLowerCase()
            .includes(searchAttributeColumns.toLowerCase())
        )
      : columnsData;

    return (
      <React.Fragment>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="columnList">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {filteredColumns.map((ite, index) => (
                  <Draggable
                    key={ite.value}
                    draggableId={ite.value}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        className="columns_field_hidden"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "4px 0",
                          ...provided.draggableProps.style,
                        }}
                      >
                        {/* Drag Handle */}
                        <span
                          {...provided.dragHandleProps}
                          style={{
                            cursor: "grab",
                            display: "flex",
                            alignItems: "center",
                            padding: "4px",
                          }}
                        >
                          <MdDragIndicator size={18} />
                        </span>

                        {/* Checkbox */}
                        <input
                          type="checkbox"
                          className="form-check-input"
                          onChange={(e) =>
                            showHiddenAttribute(e.currentTarget.checked, ite)
                          }
                          checked={
                            hiddenColumns.includes(ite.value) ? false : true
                          }
                        />

                        {/* Label */}
                        {ite.label}
                      </div>
                    )}
                  </Draggable>
                ))}

                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </React.Fragment>
    );
  };

  const showHiddenAttribute = async (checked, attr) => {
    const attrKey = attr.value; // like "phone_number"

    setHiddenColumns((prev) =>
      checked
        ? prev.filter((item) => item !== attrKey)
        : prev.includes(attrKey)
        ? prev
        : [...prev, attrKey]
    );

    const data = {
      status_type: checked ? "show" : "hide",
      attributes: [attr.value],
      app_token: process.env.REACT_APP_tattle_token,
      attribute_set_key,
      user_uuid: user_uuid ? user_uuid : localdata.user_uuid,
    };
    const responseData = await apiRequest(
      `${process.env.REACT_APP_tattle_api}/attribute/hide`,
      "POST",
      data
    );

    if (responseData.code === 200) {
      // getTattleColumnList();
      setAgGridLoadColumns(true);
    }
  };

  const searchColumnHandler = (evt) => {
    if (!evt) {
      setColumnsValueSearch({ value: "", key: "" });
    } else {
      if (dateTypeAttr.includes(evt)) {
        setIsDateFilter(true);
      }
      setColumnsValueSearch({ ...columnsValueSearch, key: evt });
    }
  };

  return (
    <div
      className="toogle-btn hidden_columns_list_parent"
      style={{ height: "37px", padding: "7px 4px" }}
      ref={hiddenColumnShows}
    >
      <Button
        onClick={() => handleToggleDropdown()}
        appearance="default"
        style={{ background: "#fff" }}
      >
        <FaRegEyeSlash size={18} />
      </Button>

      {showHiddenColumns && (
        <div
          className={`hidden_columns_list ${
            showHiddenColumns ? "dropdown-open" : "dropdown-close"
          }`}
        >
          <div className="hidden_columns_header">
            <div className="search_attribute_class">
              <input
                type="text"
                placeholder="Search..."
                className="form-control"
                onChange={searchAttributeHandler}
              />
              <span className="search_icon">
                <MdSearch size={20} color="#555" />
              </span>
            </div>
          </div>

          <div className="hidden_columns_scroll classic-scroll">
            {getTheHiddenColumns()}
          </div>

          <div className="hidden_columns_footer">
            <button className="btn btn-primary" onClick={saveAndApplyOrder}>
              Apply & Save
            </button>
            <button
              className="btn-dark-btn btn btn-dark"
              onClick={() => setShowHiddenColumns(false)}
            >
              Close
            </button>

            {/* <div className="right-buttons"> */}

            {/* </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default ColumnOrderManager;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/ColumnOrderManager.js